import axiosInstance from '@/setup/axios/axiosInstance'
import { Department, DepartmentFormData } from '../models/DepartmentModel'

interface DepartmentListResponse {
  results?: Department[]
}

// Get all departments
export function getDepartments() {
  return axiosInstance.get<Department[] | DepartmentListResponse>('/departments/')
}

// Get single department by ID
export function getDepartment(id: string) {
  return axiosInstance.get<Department>(`/departments/${id}/`)
}

// Create new department
export function createDepartment(departmentData: DepartmentFormData) {
  console.log('Creating department with data:', departmentData);
  
  return axiosInstance.post<Department>('/departments/', departmentData)
}

// Update department
export function updateDepartment(id: string, departmentData: DepartmentFormData) {
  return axiosInstance.put<Department>(`/departments/${id}/`, departmentData)
}

// Delete department
export function deleteDepartment(id: string) {
  return axiosInstance.delete(`/departments/${id}/`)
}

// Get departments by company
export function getDepartmentsByCompany(companyId: string) {
  return axiosInstance.get<Department[]>(`/departments/by-company/?company_id=${companyId}`)
}

// Get root departments (departments without parent)
export function getRootDepartments() {
  return axiosInstance.get<Department[]>('/departments/roots/')
}

// Get department hierarchy
export function getDepartmentHierarchy() {
  return axiosInstance.get<Department[]>('/departments/hierarchy/')
}

// Get employees in department
export function getDepartmentEmployees(departmentId: string) {
  return axiosInstance.get(`/departments/${departmentId}/employees/`)
} 